export default __webpack_public_path__ + "static/media/taxi.9232cec5.png";